import React, {useState} from 'react';
import {DecisionComponentDiv, DecisionTextBox, DecisionLabel, ListOfDecisionsText} from './styles/DecisionBoxComponent-style';
 



function DecisionBoxComponent(props) {
    const [Decision, setDecision] = useState('');
    const [ListOfDecisions, setListOfDecisions] = useState([]);

    function handleSubmitEnter() {
        // you have two copies of decisions. One in the local state(ListOfDecisons) and one in the main state. ListOfDecisions is used to 
        //display the decisions on the screen. The main state is used to send the data to the backend. We update main state by calling 
        //props.updateDecisionDict(Decision) and we update the local state by calling setListOfDecisions.
        setListOfDecisions(prevState => [...prevState,
            [Decision]
        ]);
        props.updateDecisionDict(Decision);
        setDecision('');
    }


    return (
        <DecisionComponentDiv>
            <DecisionLabel>Decisions: </DecisionLabel>
            <DecisionTextBox placeholder='Enter Opinioin Here' value={Decision} onChange={e => setDecision(e.target.value)} 
                onKeyDown={(ev) => {
                    if (ev.key === 'Enter') {
                        handleSubmitEnter(ev)
                    }
                }}>
            </DecisionTextBox>
            <ListOfDecisionsText>
                <ul>
                    {ListOfDecisions.map(ListOfDecisions => (
                        <li>{ListOfDecisions}</li>
                    ))}
                </ul>
            </ListOfDecisionsText>
        </DecisionComponentDiv>
    );

};

export default DecisionBoxComponent